import {FormattedMessage} from "react-intl"
import React from "react"

export default {
	load() {
		return {
			fields: {
				diagnosis: {
					label: <FormattedMessage id="Patient.Form.Medication.Diagnosis" />,
					rules: "required"
				}
			}
		}
	}
}
